export const sparklineMinMaxDiff = (data: number[]) => {
  if (!data || data.length === 0) return {};
  const min = Math.min(...data);
  const max = Math.max(...data);
  return {
    min: Math.max(0, min - (max - min) * 0.9),
    max: max + (max - min) * 0.1,
  };
};
